import { render, staticRenderFns } from "./KabKeerom.vue?vue&type=template&id=1a86dc34"
import script from "./KabKeerom.vue?vue&type=script&lang=js"
export * from "./KabKeerom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports